import { useEffect, useRef, useState } from "react";
import "./CountdownTimer.css";

const CountdownTimer = ({ days = 0, hours = 0, minutes = 0, seconds = 0 }) => {
  const [time, setTime] = useState({
    days,
    hours,
    minutes,
    seconds,
  });

  const intervalRef = useRef();

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTime((prev) => {
        let { days, hours, minutes, seconds } = prev;

        if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
          clearInterval(intervalRef.current);
          return prev;
        }

        if (seconds > 0) {
          seconds -= 1;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes -= 1;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours -= 1;
            } else {
              hours = 23;
              if (days > 0) {
                days -= 1;
              }
            }
          }
        }

        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");

  return (
  <div className="timer-wrapper">
    <div className="timer-heading">Upcoming Watches</div>
    <div className="timer-content">
      <div className="timer-block fade">
        <span className="timer-value">{pad(time.days)}</span>
        <span className="timer-label">d</span>
      </div>
      <div className="timer-separator">:</div>
      <div className="timer-block fade">
        <span className="timer-value">{pad(time.hours)}</span>
        <span className="timer-label">h</span>
      </div>
      <div className="timer-separator">:</div>
      <div className="timer-block fade">
        <span className="timer-value">{pad(time.minutes)}</span>
        <span className="timer-label">m</span>
      </div>
      <div className="timer-separator">:</div>
      <div className="timer-block fade">
        <span className="timer-value">{pad(time.seconds)}</span>
        <span className="timer-label">s</span>
      </div>
    </div>
  </div>
);
}
export { CountdownTimer };
